import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import YouTubeVideoSection from './YouTubeVideoSection';

type YouTubeVideo = {
    id: string;
    title: string;
    videoId: string;
    thumbnailUrl: string;
}

type YouTubeVideosMap = {
    [category: string]: YouTubeVideo[];
};

const youtubeVideos: YouTubeVideosMap = {
    "Data Download": [
        {
            id: "video1",
            title: "File Based Data Downloads using Globus",
            videoId: "ooQ0fBibaNM",
            thumbnailUrl: "https://img.youtube.com/vi/ooQ0fBibaNM/hqdefault.jpg"
        },
        {
            id: "video2",
            title: "Dictionary Query Tool",
            videoId: "iT976Cj6-dk",
            thumbnailUrl: "https://img.youtube.com/vi/iT976Cj6-dk/hqdefault.jpg"
        },
        {
            id: "video3",
            title: "Query Wizard",
            videoId: "8uXVzfmHPB4",
            thumbnailUrl: "https://img.youtube.com/vi/8uXVzfmHPB4/hqdefault.jpg"
        }
    ],
    "Issue Tracker": [
        {
            id: "video4",
            title: "Issue Tracker",
            videoId: "Gv6FrNF-fbw",
            thumbnailUrl: "https://img.youtube.com/vi/Gv6FrNF-fbw/hqdefault.jpg"
        }
    ]
};

const VideosPage = () => {
    const navigate = useNavigate();

    return (
        <Stack gap={2}>
            <Box>
                <Button
                    variant="tertiary"
                    onClick={() => navigate(-1)}
                    aria-haspopup={true}
                >
                    Back
                </Button>
            </Box>
            <Typography
                variant="h1"
                fontSize="2rem"
                fontWeight="600"
                textAlign="center"
                marginBottom="auto"
            >
                Get started with these training videos.
            </Typography>
            {Object.keys(youtubeVideos).sort().map(category => (
                <YouTubeVideoSection 
                    key={category}
                    category={category} 
                    videos={youtubeVideos[category]} 
                />
            ))}
        </Stack>
    )
}

export default VideosPage;
